import React, { Component } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import PropTypes from 'prop-types';

import Comments from './comments';

const propTypes = {
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

class ContractCommentsAndActivitiesRouter extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(
      R.pick(propKeys, this.props),
      R.pick(propKeys, nextProps),
    ) || !R.equals(this.state, nextState);
  }

  render() {
    const { params: { contractId }, location: { pathname } } = this.props;
    const isInMessaging = R.contains('messaging', pathname);
    return <Comments contractId={contractId} isInMessaging={isInMessaging} />;
  }
}

ContractCommentsAndActivitiesRouter.propTypes = propTypes;

const mapStateToProps = () => ({});

export default connect(mapStateToProps, () => ({}))(ContractCommentsAndActivitiesRouter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/router.jsx